import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navigation from './components/Navbar/Navigation.jsx';
import Welcome from './pages/Landingpage/Welcome.jsx';
import Services from "./pages/Services/Services.jsx";
import ClinicDetails from "./pages/ClinicDetails/ClinicalDetails.jsx";
import FaqPage from "./pages/Faq/FaqPage.jsx";
import Contact from "./pages/Contact/Contact.jsx";
import TherapyDetail from './pages/TherapyDetail/TherapyDetail.jsx';
import LocationComponent from './pages/LocationComponent/LocationComponent.jsx';

function App() {
    return (
        <Router>
            <Navigation />
            <Routes>
                <Route path="/" element={<Welcome />} />
                <Route path="/services" element={<Services />} />
                <Route path="/clinic" element={<ClinicDetails />} />
                <Route path="/location" element={<LocationComponent />} />
                <Route path="/faq" element={<FaqPage />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/services/:therapyId" element={<TherapyDetail />} />
            </Routes>
        </Router>
    );
}

export default App;
